/**
 * Procedure Categories and Procedures for MS / Diploma in Orthopaedics (MS Orthopaedics) students
 * Extracted with strict evidence from official NMC PDF (Page 10, 11, 14, 15: "Psychomotor domain & On Patients")
 */
export const ORTHOPAEDICS_PROCEDURES = {
  "Trauma, Casting, Tractions & Bedside Procedures": [
    "Application of POP Casts, Slabs, Splints, Bandages & Tractions",
    "Application of Skeletal Tractions & Skull Tongs",
    "Closed Reduction of Common Dislocations (e.g., Shoulder Dislocation)",
    "Closed Reduction of Common Fractures (e.g., Collar & Supracondylar Fractures)",
    "Joint Aspiration (Arthrocentesis) & Intra-Articular Drug Infiltration",
    "Complex Wound Care & Vacuum-Assisted Closure (VAC) Application",
    "Identification of Shock & Resuscitative Support",
  ],
  "Minor Orthopaedic & Soft Tissue Surgical Procedures": [
    "Incision and Drainage of Abscess",
    "Surgical Debridement of Open Wounds",
    "Fasciotomy for Compartment Syndrome",
    "Closed & Open Biopsies of Bone, Joint & Soft Tissue Lesions",
    "Split Thickness Skin Grafting (STSG) & Local Flaps",
    "Tendon Repair & Open Hand Injury Reconstruction",
    "Carpal Tunnel & Tarsal Tunnel Release",
    "Soft Tissue Releases for Contractures & Tendon Lengthening",
  ],
  "Operative Orthopaedic & Bone Fixation Procedures": [
    "Application of Standard External Fixators & Ilizarov External Fixator",
    "Sequestrectomy and Saucerisation for Osteomyelitis",
    "Arthrotomy of Joints (Knee, Hip, Shoulder, Ankle, Elbow)",
    "Arthrodesis of Small & Major Joints",
    "Diagnostic & Operative Arthroscopy",
    "Amputations at Various Anatomical Levels",
    "Closed / Open Reduction and Internal Fixation (DCP, LCP, Intramedullary Nailing, LRS)",
    "Bone Model & Fixation Skills (Tension Band Wiring, Plating, Interfragmentary Screws, DHS/DCS)",
    "Corrective Surgeries for CTEV, DDH & Pediatric Deformities",
  ],
};

export const ORTHOPAEDICS_CATEGORIES = Object.keys(ORTHOPAEDICS_PROCEDURES);

export const isDiplomaInOrthopaedicsDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("orthopaedics") ||
    d.includes("orthopedics") ||
    d.includes("ortho")
  );
};

export const isMSInOrthopaedicsDept = isDiplomaInOrthopaedicsDept;
